module.exports = __webpack_public_path__ + "static/media/hackathon1.f7288055.svg";